import { createContext, useContext, useEffect, useRef, useState } from "react";

const AudioCtx = createContext(null);
const TRACK = "https://cdn.pixabay.com/download/audio/2022/03/15/audio_c8e9e2c0f6.mp3?filename=ambient-piano-amp-strings-10711.mp3";
const FALLBACK = "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-8.mp3";

export function AudioProvider({ children }) {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const a = new Audio(FALLBACK);
    a.loop = true;
    a.volume = 0.25;
    audioRef.current = a;
    return () => a.pause();
  }, []);

  const toggle = () => {
    const a = audioRef.current;
    if (!a) return;
    if (playing) {
      a.pause();
      setPlaying(false);
    } else {
      a.play().then(() => setPlaying(true)).catch(() => setPlaying(false));
    }
  };

  return <AudioCtx.Provider value={{ playing, toggle }}>{children}</AudioCtx.Provider>;
}

export const useAudio = () => useContext(AudioCtx);
